export const Languages = {
  eng: {
    nav1: "Products",
    nav2: "Features",
    nav3: "Partner",
    nav4: "Help",
    nav5: "Download App",
  },
  chi: {
    nav1: "产品",
    nav2: "特征",
    nav3: "伙伴",
    nav4: "帮助",
    nav5: "下载应用程序",
  },
};
